/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_HeadingInputs */

const en_privacy_heading = /** @type {(inputs: Privacy_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const lv_privacy_heading = /** @type {(inputs: Privacy_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privātuma politika`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Privacy_HeadingInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_heading = /** @type {((inputs?: Privacy_HeadingInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_HeadingInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_heading(inputs)
	return en_privacy_heading(inputs)
});